module.exports = window["Vuex"];